import instance from "./baseRequest";

export const usersApi = {
  getUsers: async (params) => await instance.get("/auth/user", { params }),
};
